/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_0_QuestionInputs */

const en_gc_search_guides_gridcraft_online_sections_7_questions_0_question = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_0_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do I have to install GridCraft first?`)
};

const zh_gc_search_guides_gridcraft_online_sections_7_questions_0_question = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_0_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`需要先安装 GridCraft 吗？`)
};

/**
* | output |
* | --- |
* | "Do I have to install GridCraft first?" |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_0_QuestionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_7_questions_0_question = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_0_QuestionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_0_QuestionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_7_questions_0_question(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_7_questions_0_question(inputs)
});
export { gc_search_guides_gridcraft_online_sections_7_questions_0_question as "gc.search_guides.gridcraft_online.sections.7.questions.0.question" }